import { cn } from '@/shared/utils';
import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/components';

export function InternalTransferModalFooter({
  onSubmit,
  isContinueMode,
  isTransferring,
}: {
  onSubmit: () => void;
  isContinueMode: boolean;
  isTransferring: boolean;
}) {
  const { t } = useTranslation();

  return (
    <Button
      type="submit"
      variant="default"
      size="lg"
      disabled={isTransferring}
      loading={isTransferring}
      onClick={onSubmit}
      className={cn('w-full')}>
      {isContinueMode
        ? t('internalTransferModal.continueFooterButton')
        : t('internalTransferModal.transferFooterButton')}
    </Button>
  );
}
